export default process.env.NODE_ENV === 'test';
//# sourceMappingURL=index.js.map